import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, Image, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class FullWidthGalleryItemConverter extends CmsConverterService<FullWidthGalleryItemData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const title = formData.st_image_title_text?.value
    const altText = formData.st_image_alternative_text?.value
    const lazyLoad = formData.st_image_lazy_loading?.value
    return {
      image: CmsConverterService.mapImage(formData.st_image_normal_reference, lazyLoad, altText, title),
      pointOfPicture: formData.st_image_point_of_picture?.value?.identifier ?? '',
      headline: formData.st_headline ?? defaultTextInput,
      text: formData.st_text ?? defaultTextInput,
    }
  }
}

export const FULL_WIDTH_GALLERY_ITEM_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, FullWidthGalleryItemData>>('FullWidthGalleryItemConverter')

export interface FullWidthGalleryItemData extends ConvertedComponentData {
  image: Image;
  pointOfPicture: string;
  headline: TextInput;
  text: TextInput;
}
